export const Endpoints = {
    Languages: 'v0/experts-explorer/languages',
    Countries: 'v0/experts-explorer/countries',
    Majors: 'v0/experts-explorer/majors',
    Occupations: 'v0/experts-explorer/occupations',
    Degrees: 'v0/experts-explorer/degrees',
    Skills: 'v0/skills?include_levels=true',
    GetExperts: '/v0/experts-explorer/get-experts',
    ExportExpertDetails: 'v0/experts-explorer/export-expert-details',
    ExpertProfile: '/v0/experts-explorer/experts',
}
